import { render, staticRenderFns } from "./ShopHeaderFormScreen.vue?vue&type=template&id=1aa018a0&"
import script from "./ShopHeaderFormScreen.vue?vue&type=script&lang=ts&"
export * from "./ShopHeaderFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports